<template>
  <v-row>
    <v-col cols="12 py-0 pt-2 px-8">
      <h3>Danh sách category</h3>
      <div><span class="text-hint">Tìm kiếm thêm vào</span></div>
    </v-col>
    <v-col cols="12" class="px-8 py-0 pt-2">
      <v-simple-table class="table-layout table-custom table-sku">
        <thead>
          <tr>
            <th class="col-code">Danh mục</th>
            <th class="col-action text-center">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <v-autocomplete
                class="text-field text-field-no-message"
                :clearable="true"
                :items="allCategories"
                item-value="id"
                item-text="name"
                :aLight="'right'"
                placeholder="Chọn danh mục"
                attach
                outlined
                dense
                v-model="newCategoryCode"
                :disabled="isDisableActive"
                :menu-props="{ bottom: true, offsetY: true, maxHeight: '150' }"
              ></v-autocomplete>
            </td>
            <td class="text-center">
              <v-tooltip bottom class="mr-2">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#329D20" v-bind="attrs" v-on="on" @click="addCategory" :disabled="isDisableActive">
                    mdi-plus-box
                  </v-icon>
                </template>
                <span>Thêm</span> 
              </v-tooltip>
            </td>
          </tr>
          <tr v-for="(item, index) in categoryCodes" :key="index">
            <td>
              {{ allCategoriesObj[item.code] }}
            </td>
            <td class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="#959595" v-bind="attrs" v-on="on" @click="removeCategory(item, index)" :disabled="isDisableActive">
                    mdi-delete
                  </v-icon>
                </template>
                <span>Xóa</span>
              </v-tooltip>
            </td>
          </tr>
          <tr style="height: 200px;"></tr>
        </tbody>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import {
  campaignTypeOfApplicationOrder,
  campaignTypeOfApplicationSKU,
  campaignTypeOfApplicationCategory,
} from '../../../../helpers/constants';

import RepositoryFactory from '@/repositories/RepositoryFactory';
const ProductRepository = RepositoryFactory.get('product');

export default {
  props: {
    campaign: {
      type: Object,
      default: () => {},
    },
    categoryCodes: {
      type: Array,
      default: () => [],
    },
    isDisablePending: {
      type: Boolean,
      default: () => false,
    },
    isDisableActive: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
  },
  data() {
    return {
      campaignTypeOfApplicationOrder,
      campaignTypeOfApplicationSKU,
      campaignTypeOfApplicationCategory,
      allCategories: [],
      newCategoryCode: null,
      allCategoriesObj: {},
    };
  },
  computed: {
  },
  async created() {
    this.getAllCategories();
  },
  beforeDestroy() {
  },
  methods: {
    addCategory() {
      if (!this.newCategoryCode) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Chưa chọn danh mục',
        });
      }
      const isExist = this.categoryCodes.find((item) => item.code === this.newCategoryCode);
      if(isExist) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi!',
          text: 'Danh mục đã được thêm trước đó',
        });
      }

      this.categoryCodes.push({
        code: this.newCategoryCode,
      });
      this.newCategoryCode = null;
    },
    removeCategory(item, index) {
      this.categoryCodes.splice(index, 1);
    },
    async getAllCategories() {
      const res = await ProductRepository.getCategories();
      res.data.forEach((item) => {
        if (item.rootParentId === item.id) {
          this.allCategories.push({
            header: item.name,
          });
        }
        this.allCategoriesObj[item.code] = `${item.fullLevelName.join(' > ')}`;
        this.allCategories.push({
          id: item.code,
          name: `${item.fullLevelName.join(' > ')}`,
        });
      });
    },
  },
  watch: {
  }
};
</script>
<style scoped lang="scss">
.text-bold {
  font-weight: bold;
}
.gr-action {
  position: relative;
  top: 0px;
  z-index: 10;

  .btn-search {
    background: #fff !important;
    min-width: 50px;
    color: #666666 !important;
  }

  .btn-create-product {
    background: #6587FF !important;
    color: #fff !important;
  }
}
.menu__custom {
  top: calc(20% - 75px) !important;
  left: 96% !important;
  transform: translateX(-96%) !important;
}
.btn-search {
  background: #6587FF !important;
}

.box-product-type {
  width: 300px;
}

.table-custom {
  th {
    background: #E7E8FF;
    border-left: 1px solid #fff;
  }
}
</style>

<style lang="scss">
.v-select-mini {
  .v-input__slot {
    min-height: 28px !important;
    height: 28px;
  }

  .v-text-field__details {
    display: none;
  }

  .v-input__append-inner {
    margin-top: 3px !important;
  }
}

.v-tab--active {
  color: #5E64FF !important;
}
.v-tabs-slider-wrapper {
  .v-tabs-slider {
    background-color: #5E64FF !important;
  }
}
.cursor-pointer {
  cursor: pointer;
}
.text-hint {
  font-style: italic;
  font-size: 12px;
  color: #696969;
}
</style>
